/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { createRoot } from 'react-dom/client';
/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import "./editor.scss";
import NewsFeed from "../components/NewsFeed.component";

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {Element} Element to render.
 */
export default function View() {
	const rootElement = document.getElementById("rootNewsList");
	const order = rootElement.getAttribute("data-order");
	const orderBy = rootElement.getAttribute("data-order-by");

	return (
		<>
			<div className="pt-10">
				<div>
					<NewsFeed phrases={bseitEditorVars.phrases} itemsPerPage={6} orderBy={orderBy} order={order}/>
				</div>
			</div>
		</>
	);
}

const root = createRoot(document.getElementById("rootNewsList"));
root.render(<View />);
